export const followedProjects = state => state.followedProjects.items
export const followedProjectsByUserId = state => user_id => _.filter(followedProjects(state), (followedProject) =>
    followedProject.pivot.user_id == user_id
)

export const isFollowed = state => (projectId) =>
    _.find(followedProjects(state), { id: projectId })
